<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [subheader]="data.description">
      <img image src="assets/upgrade-icon.png" />
    </email-message-header>
  </ng-container>

  <ng-container body>
    <email-text
      [contents]="data.body_p1 | mailgunMarkAsHtml"
      color="light"
      presetName="inline"
      size="small"
    />
    <email-margin [height]="28" />
    <email-button
      [href]="data.go_to_billing_link"
      [label]="data.go_to_billing_text"
      theme="primary"
    />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.need_help" color="light" presetName="inline" size="small" />&nbsp;
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
